<template>
	<div v-if="item.type === 'CONTAINER'" class="attribute__group">
		<p class="attribute__group-title">{{ $t(item.title) }}</p>
		<AttributeBuilder
			v-for="col in item.attributes"
			:key="col.title"
			:item="col"
			:item-data="itemData"
			:item-structure="itemStructure"
		/>
	</div>
	<div v-else-if="itemStructure[item.title].type === 'A'" class="col-xs-12 attribute">
		<div class="image-attribute-container">
			<div class="col-sm-5">
				<label>{{ $t(itemStructure[item.title].title) }}</label>
			</div>
			<div class="col-sm-7 attr-view-content">
				<div v-for="value in attributeData" :key="value.id">
					<img v-if="value.extension === 'png' || value.extension === 'jpg' || value.extension === 'jpeg'"
						 :src="urlContext + '/attachment?id=' + value.id + '&token=' + token"
						 alt="image"
						 class="image-attribute"
						 @click="downloadFile(value.id)">
					<p v-else class="file-preview image-attribute" @click="downloadFile(value.id)">{{ value.filename }}</p>
				</div>
			</div>
		</div>
	</div>
	<div v-else-if="itemStructure[item.title].type === 'SL'" class="col-xs-12 attribute">
		<div class="single-attribute-view" v-for="(value, key, index) in itemData[item.title]" :key="index">
			<div class="col-sm-5">
				<label :title="$t(itemStructure[item.title].title) + '(' + key + ')'">{{
					$t(itemStructure[item.title].title) + '(' + key + ')'
					}}</label>
			</div>
			<div v-if="hasFormatRichText" class="col-sm-7 rich-text-view">
				<div class="rich-text-editor-default" v-html="value"/>
			</div>
			<div v-else class="col-sm-7 attr-view-content">
				<ul>
					<li>{{ value }}</li>
				</ul>
			</div>
		</div>
	</div>
	<div v-else class="col-xs-12 attribute">
		<div class="single-attribute-view" v-if="!itemStructure[item.title].multiple">
			<div class="col-sm-5">
				<label>
					<i v-if="itemStructure[item.title].expression"
					   class="fa fa-calculator"
					   aria-hidden="true"/>
					{{ $t(itemStructure[item.title].title) }}
				</label>
			</div>

				<template v-if="itemStructure[item.title].type === 'S'">
					<div v-if="hasFormatRichText" class="col-sm-7 rich-text-view">
						<div class="rich-text-editor-default" v-html="itemData[item.title]"/>
					</div>
					<div v-else class="col-sm-7 attr-view-content">
						<ul>
							<li>{{ itemData[item.title] }}</li>
						</ul>
					</div>
				</template>
			<div class="col-sm-7 attr-view-content">
				<ul v-if="(itemStructure[item.title].type === 'N') || (itemStructure[item.title].type === 'D')">
					<li>{{ itemData[item.title] }}</li>
				</ul>
				<ul v-else-if="(itemStructure[item.title].type === 'B')">
					<li>{{ itemData[item.title] ? 'Yes' : 'No' }}</li>
				</ul>
				<ul v-else-if="(itemStructure[item.title].type === 'NM')">
					<li>{{ itemData[item.title] ? (itemData[item.title].val + ' ' + itemData[item.title].mu) : '' }}
					</li>
				</ul>
				<ul v-else-if="((itemStructure[item.title].type === 'L') && itemData[item.title])">
					<li>{{ localizationAttributeL(itemData[item.title]) }}</li>
				</ul>
			</div>
		</div>
		<div class="single-attribute-view" v-else>
			<div class="col-sm-5">
				<label>{{ $t(itemStructure[item.title].title)}}</label>
			</div>
			<div class="col-sm-7 attr-view-content">
				<ul v-if="((itemStructure[item.title].type === 'L') && itemData[item.title])">
					<li v-for="(value, key) in itemData[item.title]" :key="key">{{ $t(options[value]) }}</li>
				</ul>
				<ul v-if="((itemStructure[item.title].type === 'NM') && itemData[item.title])">
					<li v-for="(value, key) in itemData[item.title]" :key="key">{{ value.val + ' ' + value.mu }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import http from 'utils/http'

export default {
	name: 'AttributeBuilder',
	props: [
		'itemData',
		'itemStructure',
		'item',
		'classificators'
	],
	data () {
		return {
			token: this.$store.getters.token,
			urlContext: process.env.VUE_APP_NODE_API_URL,
			attributeData: []
		}
	},
	computed: {
		options () {
			return this.classificators[this.itemStructure[this.item.title].classificatorType]
		},
		hasFormatRichText () {
			return this.itemStructure[this.item.title].format === 'RICH_TEXT'
		}
	},
	methods: {
		downloadFile: function (value) {
			location.href = this.urlContext + '/attachment?id=' + value + '&token=' + this.token
		},
		localizationAttributeL: function (value) {
			let result = value.replace(/_/g, '.').toLowerCase()
			return this.$t(result)
		}
	},
	async mounted () {
		let title = this.item.title
		if (this.itemStructure[title] && this.itemStructure[title].type === 'A' && this.itemData[title]) {
			const vm = this
			let attributeData = []

			for (const id of vm.itemData[vm.item.title]) {
				await http.get(`/attachment/${id}/metadata`).then(resp => {
					attributeData.push({
						id: id,
						filename: resp.data.filename,
						extension: resp.data.extension
					})
				})
			}

			vm.attributeData = attributeData
		}
	}
}
</script>

<style scoped>
	.attribute__group {
		display: inline-block;
		border: 2px solid #ccc;
		border-radius: 4px;
		padding: 0 15px 15px 15px;
		margin: 5px 10px 10px 0;
		width: 100%;
	}

	.attribute__group-title {
		font-weight: 600;
		position: relative;
		width: max-content;
		top: -10px;
		background-color: #fff;
		padding: 0 5px;
		margin: 0;
	}

	.attribute {
		padding-left: 15px;
		padding-right: 15px;
	}

	.attribute ul {
		margin: 0 0 5px 0;
	}

	.file-preview {
		font-size: 11px;
		word-break: break-all;
	}
	.file-preview:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	.rich-text-view {
		margin-bottom: 5px;
	}
</style>
